// Hostname routing: which product surface should render?
//
// In production:
//   bridgeinto.tax / *.bridgeinto.tax -> v1 (BridgeIntoTax for tax pros)
//   owners.tax / *.owners.tax         -> v2 (Owners.tax for SMB owners)
//
// In development (localhost / 127.0.0.1):
//   default                  -> v1
//   ?host=owners or ?v2=1    -> v2 (so we can iterate on v2 locally
//                                   without touching DNS)
//   localStorage.host=owners -> v2 (sticky local toggle)

export function currentHost() {
  if (typeof window === 'undefined') return 'bridgeinto';
  const h = (window.location.hostname || '').toLowerCase();

  if (h.endsWith('owners.tax')) return 'owners';
  if (h.endsWith('bridgeinto.tax')) return 'bridgeinto';

  // Local dev: query string wins, then localStorage, then default to v1.
  const qs = new URLSearchParams(window.location.search);
  if (qs.get('host') === 'owners' || qs.get('v2') === '1') return 'owners';
  try {
    if (window.localStorage.getItem('host') === 'owners') return 'owners';
  } catch {
    /* private mode etc. */
  }
  return 'bridgeinto';
}

export function isOwnersHost() {
  return currentHost() === 'owners';
}

// Which subdomain inside owners.tax. Used by the v2 router to pick
// the marketing site vs the app vs the books surface.
export function ownersSubdomain() {
  if (typeof window === 'undefined') return 'root';
  const h = (window.location.hostname || '').toLowerCase();
  if (h === 'app.owners.tax') return 'app';
  if (h === 'books.owners.tax') return 'books';
  return 'root';
}
